var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"taux-examens mt-3"},[_c('div',{staticClass:"card brder-radius-x"},[_c('div',{staticClass:"card-body brder-radius-x"},[_c('div',{staticClass:"basic-flex mb-2"},[_c('h3',{staticClass:"text-secondary"},[_vm._v("Examens")])])])])])
}]

export { render, staticRenderFns }